import { render, staticRenderFns } from "./pro-dialog.vue?vue&type=template&id=32473ce8"
import script from "./pro-dialog.vue?vue&type=script&lang=js"
export * from "./pro-dialog.vue?vue&type=script&lang=js"
import style0 from "./pro-dialog.vue?vue&type=style&index=0&id=32473ce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports